export default "__VITE_ASSET__BKRdZDSy__"